import { LevelRow, Side } from '../types/survey';

type Props = {
  rows: LevelRow[];
  setRow: (id: string, key: keyof LevelRow, value: string) => void;
  deleteRow: (id: string) => void;
};

const fields: (keyof LevelRow)[] = [
  'chainage',
  'offset',
  'side',
  'bs',
  'is',
  'fs',
  'tbmValue',
  'remarks',
];

export default function LevelTable({ rows, setRow, deleteRow }: Props) {
  const move = (rowIndex: number, fieldIndex: number, key: string) => {
    let r = rowIndex;
    let f = fieldIndex;

    if (key === 'Enter') r++;
    if (key === 'ArrowRight') f++;
    if (key === 'ArrowLeft') f--;
    if (key === 'ArrowDown') r++;
    if (key === 'ArrowUp') r--;

    if (f >= fields.length) {
      f = 0;
      r++;
    }

    if (f < 0) {
      f = fields.length - 1;
      r--;
    }

    if (r < 0 || r >= rows.length) return;

    const selector = `[data-r="${r}"][data-f="${fields[f]}"]`;
    const next = document.querySelector(selector) as HTMLElement | null;
    next?.focus();
  };

  const nav = (
    i: number,
    f: number,
    e: React.KeyboardEvent<HTMLElement>
  ) => {
    if (
      ['Enter', 'ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].includes(
        e.key
      )
    ) {
      e.preventDefault();
      move(i, f, e.key);
    }
  };

  return (
    <div className="level-table-wrapper">
      <table className="level-table">
        <thead>
          <tr>
            {[
              'Chainage',
              'Offset',
              'Side',
              'BS',
              'IS',
              'FS',
              'HI',
              'CH',
              'Offset(+/-)',
              'RL',
              'TBM Value',
              'Remarks',
              '',
            ].map((h) => (
              <th key={h}>{h}</th>
            ))}
          </tr>
        </thead>

        <tbody>
          {rows.map((row, i) => (
            <tr
              key={row.id}
              className={
                row.remarks === 'CLOSING TBM'
                  ? 'closing-tbm-row'
                  : row.remarks?.startsWith('CP-')
                  ? 'cp-row'
                  : ''
              }
            >
              <td>
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  data-r={i}
                  data-f="chainage"
                  value={row.chainage}
                  onKeyDown={(e) => nav(i, 0, e)}
                  onChange={(e) =>
                    setRow(row.id, 'chainage', e.target.value)
                  }
                />
              </td>

              <td>
                <input
                  type="text"
                  inputMode="decimal"
                  pattern="[0-9.]*"
                  data-r={i}
                  data-f="offset"
                  value={row.offset}
                  onKeyDown={(e) => nav(i, 1, e)}
                  onChange={(e) =>
                    setRow(row.id, 'offset', e.target.value)
                  }
                />
              </td>

              <td>
                <select
                  data-r={i}
                  data-f="side"
                  value={row.side}
                  onKeyDown={(e) => nav(i, 2, e)}
                  onChange={(e) =>
                    setRow(row.id, 'side', e.target.value as Side)
                  }
                >
                  <option value=""></option>
                  <option value="Center">Center</option>
                  <option value="LHS">LHS</option>
                  <option value="RHS">RHS</option>
                </select>
              </td>

              <td>
                <input
                  type="text"
                  inputMode="decimal"
                  pattern="[0-9.]*"
                  data-r={i}
                  data-f="bs"
                  value={row.bs}
                  onKeyDown={(e) => nav(i, 3, e)}
                  onChange={(e) => setRow(row.id, 'bs', e.target.value)}
                />
              </td>

              <td>
                <input
                  type="text"
                  inputMode="decimal"
                  pattern="[0-9.]*"
                  data-r={i}
                  data-f="is"
                  value={row.is}
                  onKeyDown={(e) => nav(i, 4, e)}
                  onChange={(e) => setRow(row.id, 'is', e.target.value)}
                />
              </td>

              <td>
                <input
                  type="text"
                  inputMode="decimal"
                  pattern="[0-9.]*"
                  data-r={i}
                  data-f="fs"
                  value={row.fs}
                  onKeyDown={(e) => nav(i, 5, e)}
                  onChange={(e) => setRow(row.id, 'fs', e.target.value)}
                />
              </td>

              <td>
                <input value={row.hi} readOnly />
              </td>

              <td>
                <input value={row.ch} readOnly />
              </td>

              <td>
                <input value={row.offsetSigned} readOnly />
              </td>

              <td>
                <input value={row.rl} readOnly />
              </td>

              <td>
                <input
                  type="text"
                  inputMode="decimal"
                  pattern="[0-9.]*"
                  data-r={i}
                  data-f="tbmValue"
                  value={row.tbmValue}
                  onKeyDown={(e) => nav(i, 6, e)}
                  onChange={(e) =>
                    setRow(row.id, 'tbmValue', e.target.value)
                  }
                />
              </td>

              <td>
                <input value={row.remarks} readOnly />
              </td>

              <td>
                <button onClick={() => deleteRow(row.id)}>×</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
